import { ValidationError } from '../../../../lib/models/validation/validation-error';
import { ReferenceDataService } from './../../../../lib/services/reference-data.service';

import {
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import { Subscription } from 'rxjs';
import { ApplicationFormStore } from '../../services/application-form-store';

@Component({
  selector: 'boi-validation-error',
  templateUrl: './validation-error.component.html',
  styleUrls: ['./validation-error.component.scss']
})
export class ValidationErrorComponent implements OnInit, OnChanges, OnDestroy {
  public validationErrors: Array<ValidationError>;
  private dataSubscription: Subscription;
  @Input() public propertyNames: Array<string>;
  @Output() public readonly errorChange = new EventEmitter<boolean>();

  constructor(
    private applicationStore: ApplicationFormStore,
    private referenceDataService: ReferenceDataService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.getValidationErrors();
    this.dataSubscription = this.applicationStore.dataObservable.subscribe((data) => {
      this.getValidationErrors();
      this.cdr.detectChanges();
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.getValidationErrors();
  }

  public getValidationErrors(): void {
    if (this.applicationStore.validationErrors) {
      this.validationErrors = this.applicationStore.isSubmitted
        ? this.applicationStore.validationErrors.FullValidationErrors
        : this.applicationStore.validationErrors.BusinessValidationErrors;
    } else {
      this.validationErrors = new Array<ValidationError>();
    }

    const hasErrors =
      this.propertyNames &&
      this.validationErrors.some((err: ValidationError) => this.propertyNames.indexOf(err.key) > -1);
    this.errorChange.emit(hasErrors);
  }

  public localizeErrorMessage(validationErrorName): string {
    let localizedError;
    if (this.validationErrors) {
      if (this.validationErrors.find((error) => error.key === validationErrorName)) {
        localizedError = this.referenceDataService.getLocalizeErrorMessage(
          this.validationErrors.find((error) => error.key === validationErrorName)
        );
      }

      return localizedError;
    }
  }

  ngOnDestroy(): void {
    if (this.dataSubscription) {
      this.dataSubscription.unsubscribe();
    }
  }
}
